import { render } from "./CustomerBalance.vue?vue&type=template&id=6bc435b6&scoped=true"
import script from "./CustomerBalance.vue?vue&type=script&lang=js"
export * from "./CustomerBalance.vue?vue&type=script&lang=js"

import "./CustomerBalance.vue?vue&type=style&index=0&id=6bc435b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc435b6"]])

export default __exports__